export default function (customTheme, customThemeOpts, itemsCount) {
  const widgetName = customTheme;
  const widgetOpts = customThemeOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: itemsCount,
    itemsPerPanel: 1,
    hasImages: true,
    textOverImage: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ["all"],

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        if (widgetName == "fairSocialIcons") {
          $widget.parent().parent().remove();
        } else if (widgetName == "sFloridaSocialSideBar") {
          $widget.remove();
        } else {
          $widget.parent().remove();
        }
      } else {
        createSocialIcons(data.items);
      }
    },
  });

  function createSocialIcons(widgetData) {
    $widget.find(".card-content").remove();
    $widget.find(".card-widget-item").each(function (x) {
      const { Title, URL } = widgetData[x];
      const $card = $(this);
      $card.attr("aria-label", Title);

      if (!URL) {
        $card.remove();
      }
    });
  }
}
